module.exports = __webpack_public_path__ + "static/media/icon-plus2.51be3ebe.svg";